module.exports = "<div [class.loader-hidden]=\"!show\">\n  <div class=\"loader-overlay\">\n    <div class=\"loading\">\n      <div *ngIf=\"show\"><img src=\"../../../assets/loader.gif\"/></div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/loader/loader.component.html
// module id = ./src/app/pages/loader/loader.component.html
// module chunks = main